import React from 'react';
import { Form, Typography } from 'antd';
import { Input, Button, notification } from '@gamesb42/ui-kit';
import { resetPassword } from 'api/users';
import EmailSentModal from './EmailSentModal';

const { Title, Text } = Typography;

interface ForgotPasswordFormProps {
  onBack: () => void;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ onBack }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [sentEmail, setSentEmail] = React.useState('');

  const onFinish = async (values: { email: string }) => {
    setLoading(true);
    try {
      await resetPassword({ email: values.email });

      // Показываем модалку вместо notification
      setSentEmail(values.email);
      setShowSuccessModal(true);
      form.resetFields();
    } catch (error) {
      console.error('Reset password error:', error);
      notification.error({
        theme: 'dark',
        message: 'Failed to Send Reset Email',
        description: 'Failed to send password reset email. Please try again.',
        placement: 'bottomLeft',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleModalClose = () => {
    setShowSuccessModal(false);
    // Возвращаемся на форму логина после закрытия модалки
    onBack();
  };

  return (
    <>
      <Title level={2} style={{ marginBottom: '20px', textAlign: 'left' }}>
        Forgot Password
      </Title>

      <div style={{ marginBottom: '32px' }}>
        <Text style={{ color: '#606176' }}>Enter your E-mail</Text>
      </div>

      <Form form={form} layout="vertical" onFinish={onFinish} size="large">
        <Form.Item
          name="email"
          rules={[
            { required: true, message: 'Please input your email!' },
            { type: 'email', message: 'Please enter a valid email!' },
          ]}
        >
          <Input label="Email" placeholder="Email*" size="large" />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
            violet
            style={{
              color: '#fff',
              width: '94px',
            }}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>

      <EmailSentModal visible={showSuccessModal} email={sentEmail} onClose={handleModalClose} />
    </>
  );
};

export default ForgotPasswordForm;

